import { Component, OnInit, Input  } from '@angular/core';
import { DatePipe } from '@angular/common';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { MatDialog, MatDialogRef, MatDialogConfig } from '@angular/material';


import { Cours } from '../../model/cours.model';
import { CoursService } from '../../service/cours.service';
import { SearchCoursCriteria } from '../../model/searchcourscriteria.model';

import { Client } from '../../model/client.model';
import { ResaMultiple } from '../../model/resaMultiple.model';
import { Reservation } from '../../model/reservation.model';

import { Activite } from '../../model/activite.model';
import { ActiviteService } from '../../service/activite.service';

import { ClientService } from '../../service/client.service';
import { ReservationService } from '../../service/reservation.service';
import { UtilsService } from '../../service/utils.service';

import { ConfirmDialogModel, ConfirmDialogComponent } from '../../administration/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-cours',
  templateUrl: './cours.component.html',
  styleUrls: ['./cours.component.scss']
})
export class CoursComponent implements OnInit {
  public form: FormGroup;

  lescours: Cours[];
  datePipe: DatePipe;

  activites: Activite[];

  autoHide = 3000;
  addExtraClass = false;
  actionButtonLabel = 'Retry';
  action = false;
  result: string = '';

  dialogRef: MatDialogRef<AllClientComponent>;
  lastCloseResult: string;
  config: MatDialogConfig = {
    disableClose: false,
    width: '',
    height: '400px',
    panelClass: 'epsSelectorPanel',
    position: {
      top: '',
      bottom: '',
      left: '',
      right: ''
    }
  };

  clients: Client[];



  constructor(private coursService: CoursService,
              public snackBar: MatSnackBar,
              private fb: FormBuilder,
              private activiteService: ActiviteService,
              private clientService: ClientService,
              private reservationService: ReservationService,
              private utils: UtilsService,
              public dialog: MatDialog) {

    this.datePipe =  new DatePipe('en-US');

    this.activiteService.getAll().subscribe(res => {
      this.activites = res
    });

    this.form = this.fb.group({
      designation: null,
      datedebut: null,
      datefin: null
    });
  }

  ngOnInit() {


    const datedujour = new Date();

    this.coursService.getAll(this.datePipe.transform(datedujour,'yyyy-MM-dd')).subscribe(res => {
      this.lescours = res
    });

    this.clientService.getAllClient().subscribe(membres => {
      this.clients = membres;
    });



  }

  cancel(cours: Cours, index: number){

      let coursDate = new Date(cours.datedebut);

      //confirm dialog
    const message = `Voulez-vous vraiment supprimer ce cours de <u>` + this.utils.extractDesignation (cours.designation) + ' du ' + this.utils.ConvertToDate(coursDate) + ' à ' + this.utils.ConvertToTime(coursDate) + '</u>';

    const dialogData = new ConfirmDialogModel("Suppression cours", message);

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "400px",
      panelClass: 'confirm-dialog',
      data: dialogData
    });

    dialogRef.afterClosed().subscribe(dialogResult => {
      this.result = dialogResult;
      //  console.log(this.result);

       if(this.result){
          // delete function
          this.coursService.delete(cours.idcours).subscribe(res => {
          const config   = new MatSnackBarConfig();
          this.lescours.splice(index, 1);
          config.duration = this.autoHide;
          config.extraClasses = this.addExtraClass ? ['party'] : null;
          this.snackBar.open('Cours annulé.', this.action && this.actionButtonLabel, config);
          });
       }

    });

  }

  onSubmit(criteres: any) {
    // console.log(criteres);
    const searchCritere = new SearchCoursCriteria();


    if (criteres.designation == null) {
      searchCritere.designation = '';
    } else {
      searchCritere.designation = criteres.designation;
    }

    if (criteres.datedebut == null) {
      searchCritere.datedebut = null;
    } else {
      const datedebut = new Date(criteres.datedebut);
      searchCritere.datedebut = datedebut;
    }

    if (criteres.datefin == null) {
      searchCritere.datefin = null;
    } else {
      const datefin = new Date(criteres.datefin);
      searchCritere.datefin = datefin;
    }


    this.coursService.search(searchCritere).subscribe(res => {
      // console.log(res);
      this.lescours = res;
    });



  }

  reserver(idcours, index: number) {

    this.dialogRef = this.dialog.open(AllClientComponent, this.config);
    this.dialogRef.componentInstance.idCours = idcours;
    this.dialogRef.componentInstance.addremove = 'add';
    // this.dialogRef.componentInstance.clients = this.clients;

    this.dialogRef.afterClosed().subscribe(result => {

      this.coursService.get(idcours).subscribe(moncours => {
        this.lescours[index].participants = moncours.participants
      });


      // var datedujour = new Date();
      // this.coursService.getAll(this.datePipe.transform(datedujour,'yyyy-MM-dd')).subscribe(res =>{
        // this.lescours = res
      // });

      this.lastCloseResult = result;
      this.dialogRef = null;

    });


  }


  remove(idcours, index: number) {

    this.dialogRef = this.dialog.open(AllClientComponent, this.config);
    this.dialogRef.componentInstance.idCours = idcours;
    this.dialogRef.componentInstance.addremove = 'remove';
    // this.dialogRef.componentInstance.clients = this.clients;

    this.dialogRef.afterClosed().subscribe(result => {

      this.coursService.get(idcours).subscribe(moncours => {
        this.lescours[index].participants = moncours.participants
      });


      // var datedujour = new Date();
      // this.coursService.getAll(this.datePipe.transform(datedujour,'yyyy-MM-dd')).subscribe(res =>{
        // this.lescours = res
      // });

      this.lastCloseResult = result;
      this.dialogRef = null;

    });
  }




}


@Component({
  selector: 'app-allClient-dialog',
  template: `
  <h5 class="mt-0">Sélectionner des participants</h5>
   <mat-form-field class="example-full-width">
     <input type="text" placeholder="search client" aria-label="Number"  matInput  (keyup) = "filter($event)"  autocomplete="off">
  </mat-form-field>

  <mat-selection-list #row>
   <mat-list-option *ngFor="let client of clients" [value]="client">
    {{client.prenom}} {{client.nom}}
   </mat-list-option>
  </mat-selection-list>
  <p>
     Participants selectionnés: {{row.selectedOptions.selected.length}}
  </p>


  <div class="text-center">
     <button class="mat-grey-400" mat-raised-button (click)="valider(row)" >Valider</button>
  </div>`

})
export class AllClientComponent implements OnInit  {


  @Input()
  idCours: any;

  @Input()
  idEspace: any;

  @Input()
  addremove: any;

  clients: Client[];

  selectedclient: Client[];

  autoHide = 3000;
  addExtraClass = false;
  actionButtonLabel = 'Retry';
  action = false;

  constructor(public dialogRef: MatDialogRef <AllClientComponent>,
              private reservationService: ReservationService,
              private clientService: ClientService,
              public snackBar: MatSnackBar) {

    // console.log(this.idCours);


  }

  ngOnInit() {

    if (this.addremove === 'add'){
      this.clientService.getClientNoResa(this.idCours).subscribe(res => {
        this.clients = res;
      });
    }

    if (this.addremove === 'remove') {
      this.clientService.getClientResa(this.idCours).subscribe(res => {
        this.clients = res;
      });
    }


  }

 filter(event){
    // console.log(" event ",event.target.value)
    this.clientService.searchClientResa(this.idCours, event.target.value).subscribe(res => {
         this.clients = res;
    });
 }

  valider(row) {
    // console.log(row.selectedOptions.selected);
    const resaMultiple = new ResaMultiple();
    this.selectedclient = [];

    row.selectedOptions.selected.forEach(element => {
      this.selectedclient.push(element.value)



    });

    resaMultiple.coursId = this.idCours;
    resaMultiple.clients = this.selectedclient;
    // console.log(resaMultiple);

    if (this.addremove === 'add') {
      this.reservationService.createMultiple(resaMultiple).subscribe(res => {
        // console.log(res);
        const config = new MatSnackBarConfig();
        if (res === true) {
          config.duration = this.autoHide;
          config.extraClasses = this.addExtraClass ? ['party'] : null;
          this.snackBar.open('Votre réservation a été enregistrée avec succès.', this.action && this.actionButtonLabel, config);
        } else {
          config.duration = this.autoHide;
          config.extraClasses = this.addExtraClass ? ['party'] : null;
          this.snackBar.open('Place non disponible.', this.action && this.actionButtonLabel, config);
        }




      }, error => {
        const config = new MatSnackBarConfig();
        config.duration = this.autoHide;
        config.extraClasses = this.addExtraClass ? ['party'] : null;
        this.snackBar.open('Une erreur a été rencontrée lors de l\'enregistrement de votre reservation.', this.action && this.actionButtonLabel, config);

      });
    }
    if (this.addremove === 'remove') {
      this.reservationService.deleteMultiple(resaMultiple).subscribe();

    }



    this.dialogRef.close();
  }

}



// WEBPACK FOOTER //
// /home/codevi/Documents/PROJET/resa-parklife/front/src/app/administration/cours/cours.component.ts